import './polyfills.js'
import manager from './manager'

export default manager



// WEBPACK FOOTER //
// ./app/statamic/resources/js/components/toast/main.js